import React, {FC} from 'react'
import {useCognitoAuth} from '../core/CognitoAuth'
import {resetAuthDialogFlag, getGlobalTokenExpirationHandler} from '../core/AuthErrorInterceptor'

interface AuthErrorModalProps {
  isOpen: boolean
  onClose: () => void
}

export const AuthErrorModal: FC<AuthErrorModalProps> = ({isOpen, onClose}) => {
  const {cognitoLogout} = useCognitoAuth()

  const handleLogin = async () => {
    try {
      // First clear the auth state
      const tokenExpirationHandler = getGlobalTokenExpirationHandler()
      if (tokenExpirationHandler) {
        tokenExpirationHandler()
      }

      // Then logout and redirect
      await cognitoLogout()
    } catch (error) {
      console.error('Error during logout:', error)
      // Force redirect to login page
      window.location.href = '/signin'
    }
  }

  const handleCancel = () => {
    resetAuthDialogFlag()
    onClose()
  }

  if (!isOpen) return null

  return (
    <div
      className='modal fade show'
      style={{
        display: 'block',
        zIndex: 9999,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
      }}
      tabIndex={-1}
    >
      <div className='modal-dialog modal-dialog-centered ob-dialog' style={{zIndex: 10000}}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title'>
              <i className='fas fa-exclamation-triangle text-warning me-2'></i>
              Authentication Required
            </h5>
            <button
              type='button'
              className='btn-close'
              onClick={handleCancel}
              aria-label='Close'
            ></button>
          </div>
          <div className='modal-body'>
            <p className='mb-0'>
              Your session has expired or you are not logged in. Please log in to continue.
            </p>
          </div>
          <div className='modal-footer'>
            <button type='button' className='btn btn-secondary' onClick={handleCancel}>
              Cancel
            </button>
            <button type='button' className='btn btn-primary' onClick={handleLogin}>
              <i className='fas fa-sign-in-alt me-2'></i>
              Log In
            </button>
          </div>
        </div>
      </div>
      <div
        className='modal-backdrop fade show'
        style={{
          zIndex: 9998,
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }}
      ></div>
    </div>
  )
}
